<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <image-list
    entity-name="bannerImg"
    :model="model"
    icon="mdi-calendar-today"
  />
</template>

<script>

import BannerImage from '@/model/dataLayer/api/restaurant/BannerImage'
import ImageList from '@/views/widget/commonLogic/ImageList.vue'

export default {
  components: {
    ImageList
  },
  data: function () {
    return ({
      model: BannerImage
    })
  }
}
</script>
